import Layout from '@/app/modules/_shared/layout/main/containers/layout/layout.vue';
import AuthLayout from '@/app/modules/_shared/layout/main/containers/auth-layout/auth-layout.vue';
import ActivityNotifications from '@/app/modules/_shared/notifications/activity-notifications/activity-notifications.vue';
import FeedbackForm from '@/app/modules/_shared/modals/feedback-form/feedback-form.vue';

export default {
  name: 'app',
  components: {
    Layout,
    AuthLayout,
    ActivityNotifications,
    FeedbackForm,
  },
  computed: {
    auth() {
      return this.$store.getters['auth/loggedIn']
        && this.$route.path !== '/auth/sign-in'
        && this.$route.path !== '/invite'
        && this.$route.path !== '/on-board';
    },
  },
  mounted() {
    const hubspotScript = document.createElement('script');
    hubspotScript.setAttribute('src', `https://js.hs-scripts.com/${process.env.VUE_APP_HUBSPOT_ID}.js`);
    // console.log('HUBSPOT_ID', );
    document.head.appendChild(hubspotScript);
  },
  watch: {
    auth(loggedIn) {
      if (!loggedIn
        && this.$route.path !== '/invite'
        && this.$route.path !== '/on-board') {
        this.$store.dispatch('auth/signOut');
        this.$router.push('/auth/sign-in');
      }
    },
  },

};
